import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import patternManagerSlice from './patternManagerSlice';

export const store = configureStore({
  reducer: {
    patternManager: patternManagerSlice
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
